const translations = {
    applicator: 'Applicator',
    createProductUsageReport: 'Create Product Usage Report',
    customer: 'Customer',
    job: 'Job',
    productUsageReportError: 'Error Fetching List Of Product Usage Reports',
    productUsageReports: 'Product Usage Reports',
    site: 'Site',
    status: 'Status',
    time: 'Time'
};

export default translations;
